import React, { useEffect, useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { getUserClaimData } from '../../../core/services/all.api';
import { formatDateV2 } from '../../../core/helper/date-format';

const ClaimHistory = () => {
    const [getUserClaims, setGetUserClaims] = useState(null);
    const [loading, setLoading] = useState(true);
    const getData = async () => {
        setLoading(() => true)
        const stakeData = await getUserClaimData()
        // console.log(stakeData)
        if (stakeData.status && (stakeData.data).length > 0) {
            setGetUserClaims(() => stakeData.data)
        }
        else {
            setGetUserClaims(() => null)
        }
        setLoading(() => false)
    }
    useEffect(() => {
        getData();
    }, [])
    const statusAnalysis = (status) => {
        if (status === 3) {
            return 'Blank'
        }
        else if (status === 1) {
            return 'Approved'
        }
        else if (status === 2) {
            return 'Rejected'
        }
        else if (status === 0) {
            return 'Pending'
        }
        else {
            return ''
        }
    }
    return (
        <div className='px-3 my-3'>
            <div>
                <h1 style={{ fontSize: '1.5rem' }}><strong>Claim History</strong></h1>
            </div>
            <div className='mt-3' style={{ maxHeight: 'calc(96vh - 150px)', overflow: 'auto' }}>
                <Table responsive bordered hover variant="dark" className="custom-table-claim"
                    style={{ backgroundColor: 'transparent' }}
                >
                    <thead>
                        <tr>
                            <th className='bg-transparent'>Date</th>
                            <th className='bg-transparent'>Plan</th>
                            <th className='bg-transparent'>Stake Date</th>
                            <th className='bg-transparent'>Stake Amount</th>
                            <th className='bg-transparent'>Monthly Claim</th>
                            <th className='bg-transparent'>Capital Withdraw</th>
                            <th className='bg-transparent'>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (loading && !getUserClaims) &&
                            <tr>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}><Spinner aria-label="Center-aligned spinner example" size={'md'} /></td>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            </tr>
                        }
                        {(getUserClaims && getUserClaims.length > 0 && !loading) ? getUserClaims.map((el, index) => {
                            const type = el?.type;
                            return (
                                <tr key={index}>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{formatDateV2(type === 'claim' ? el?.createdAt : el?.withdrawReqDate) || 0}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>Plan {type === 'claim' ? el?.stakeId?.name : el?.name}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}>{formatDateV2(type === 'claim' ? el?.stakeId?.createdAt : el?.createdAt) || 0}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>${type === 'claim' ? el?.stakeId?.amount : el?.amount}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{type === 'claim' ? '$' + el?.claimAmount : 'NA'}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{type === 'claim' ? 'NA' : '$' + el?.withdrawn}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{statusAnalysis(type === 'claim' ? el?.status : el?.withdrawStatus)}</td>
                                </tr>)
                        }

                        ) : <tr>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}>No Data!</td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                        </tr>}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ClaimHistory;